var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorsVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CACAFF"
    },
    d: "M345.293,248.562c0.069-1.248,0.111-2.504,0.111-3.77c0-37.096-30.072-67.169-67.169-67.169 c-28.938,0-53.6,18.301-63.048,43.96c-11.713-3.232-24.047-4.967-36.787-4.967c-76.205,0-137.981,61.776-137.981,137.981 c0,17.918,3.417,35.037,9.632,50.744h373.115c11.862-16.295,18.866-36.354,18.866-58.053 C442.032,293.421,398.902,249.634,345.293,248.562z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 34.226,
    y1: 405.34,
    x2: 442.032,
    y2: 405.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3FF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M70.47,227.27 c0,0,17.256,93.605,18.977,155.535"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M79.469,229.667c-3.518,2.746-8.112,3.735-12.476,2.799c-4.817-1.033-10.666-2.998-11.263-6.509 c-1.032-6.062,10.15-2.762,10.15-2.762s-9.633-4.805-7.741-11.966c1.892-7.161,10.666,0.215,11.182,5.387 c0,0,0.688-7.562,6.881-6.872c6.193,0.69,0,11.866,0,11.866s3.44-3.951,6.021-2.574c2.58,1.376-0.172,6.709-4.817,9.289 C77.405,228.324,83.191,226.762,79.469,229.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3FF"
    },
    d: "M57.794,405.34c0,0-8.601-24.944-6.537-55.909l17.203,33.373c0,0-5.505-58.909-4.473-101.19 c0,0,19.267,57.495,25.46,93.621c0,0-6.537-66.794,5.849-120.787c0,0,7.913,67.803,7.225,108.401c0,0,2.818-44.073,29.621-84.827 l-7.946,89.987c0,0,8.057-18.235,20.715-30.277l-11.429,67.607H57.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3FF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M109.812,257.358 c0,0-6.259,70.055-6.259,117.878"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M118.428,261.425c-4.665,2.684-10.584,1.588-14.287-2.318c-1.631-1.721-3.444-3.789-5.061-5.995 c-4.301-5.865,0.344-8.954,4.129-3.969c0,0-5.337-7.374-0.002-12.376c5.335-5.002,5.851,10.882,5.851,10.882 s1.72-10.551,7.741-8.487c6.021,2.064-1.032,13.95-1.032,13.95s3.785-4.477,5.849-2.332c2.064,2.145-1.032,6.445-5.677,8.165 c0,0,3.613-1.892,4.387,0C120.635,259.702,119.858,260.602,118.428,261.425z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M220.015,299.626h-8.082l-16.845-60.464l10.002,3.086c0.124,0.041,0.237,0.072,0.351,0.124 c4.593,1.559,7.948,5.553,8.639,10.363c0.661,4.552,1.311,10.631,1.373,17.258c0.021,1.713,0.175,3.416,0.464,5.099 L220.015,299.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M183.589,214.906c0,0-0.602-4.129-3.484-5.806c0,0,1.892,0.43,2.881,1.677 c0,0,0.301-2.666-0.731-4.043c0,0,3.14,3.484,2.537,7.956L183.589,214.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M184.047,215.483c0,2.349-1.904,4.253-4.253,4.253s-4.253-1.904-4.253-4.253 s1.904-4.253,4.253-4.253S184.047,213.134,184.047,215.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M186.414,217.214c-0.553,1.843-1.894,3.068-2.995,2.738c-1.1-0.331-1.544-2.092-0.99-3.935 c0.553-1.843,1.894-3.068,2.995-2.738C186.524,213.61,186.968,215.372,186.414,217.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M199.692,237.485v6.714h-8.835v-7.71c0-1.073-0.289-2.106-0.795-3.014 c-0.485-0.857-1.156-1.621-1.992-2.209c-3.406-2.446-5.471-6.668-4.841-11.302c0.702-5.223,4.934-9.434,10.167-10.115 c5.119-0.671,9.713,1.93,11.973,6.007c0.784,1.424,1.29,3.014,1.435,4.717c0.021,0.175,0.031,0.361,0.041,0.537 C207.65,230.657,206.533,237.356,199.692,237.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M200.797,214.71c1.548,3.551-5.718,0.516-5.718,0.516c2.426,3.489-5.192,0.97-5.192,0.97 c5.305,8.959,1.631,15.307,0.175,17.279c-0.485-0.857-1.156-1.621-1.992-2.209c-3.406-2.446-5.471-6.668-4.841-11.302 c0.702-5.223,4.934-9.434,10.167-10.115c5.119-0.671,9.713,1.93,11.973,6.007C204.523,216.63,200.797,214.71,200.797,214.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M192.921,226.002c0,0-2.903-4.774-5.935-1.871c-3.032,2.903,2.451,9.999,5.935,6.516"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB4D4B",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M187.631,227.099c0,0,0.408-2.513,1.882-1.676c1.473,0.837,1.796,3.353,1.796,3.353"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB4D4B",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M190.151,225.958c0,0-1.413,1.793,0,3.657"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB4D4B",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M201.243,223.342v3.091l2.88,0.271c0.475,0.045,0.669,0.634,0.314,0.952l-2.291,2.052"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#171659"
    },
    cx: 197.792,
    cy: 224.396,
    rx: 0.484,
    ry: 1.054
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M205.369,224.396c0,0.582-0.217,1.054-0.484,1.054c-0.267,0-0.484-0.472-0.484-1.054 c0-0.582,0.217-1.054,0.484-1.054C205.152,223.342,205.369,223.814,205.369,224.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB4D4B",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M197.308,230.776c0,0,0.774,2.355,3.064,2.387"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB4D4B",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M199.692,237.485c-2.513,0-5.384-1.548-6.513-4.322"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M185.094,260.838c0.43-8.227-2.683-12.794-4.504-14.744c-3.403,2.734-5.474,6.896-5.474,11.399 v49.358h14.498l-5.725-23.134C183.89,283.717,184.492,272.363,185.094,260.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M188.535,258.949c0,0,0.454,13.263-4.346,19.074c0.237-4.387,0.568-10.755,0.908-17.185 c0.423-8.226-2.684-12.799-4.51-14.739c0.991-0.795,2.085-1.476,3.282-2.002l4.366-1.92v-2.024c0-1.058,0.832-1.923,1.888-1.972 c2.361-0.11,6.469-0.146,9.577,0.663c0.63,0.164,1.104,0.679,1.208,1.321l0.136,0.835l4.046,1.249 c0.15,0.126,0.358,0.301,0.509,0.428c3.894,7.531,5.254,12.565,5.468,16.273H188.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C3EA"
    },
    d: "M213.017,299.626c-1.672-9.372-4.304-25.009-4.015-29.159c0.25-3.491,2.39-6.088,2.069-11.522 h-22.537c0,0,0.452,13.265-4.343,19.074c-0.184,3.474-0.301,5.697-0.301,5.697l5.725,23.134h24.724 C214.339,306.852,213.781,303.889,213.017,299.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#54C3EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M189.523,259.978 c0,0-0.579-10.033-5.654-15.882"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#54C3EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M209.461,259.978 c0,0-1.455-12.546-6.53-18.395"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M208.589,249.143c1.652,4.139,2.333,7.277,2.477,9.806"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M184.189,278.023c0.237-4.387,0.568-10.755,0.908-17.185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.563,
    y: 305.393,
    style: {
      fill: "#6A6AE2"
    },
    width: 265.954,
    height: 99.948
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.357,
    y: 167.427,
    style: {
      fill: "#4E4ECE"
    },
    width: 3.934,
    height: 139.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.789,
    y: 167.427,
    style: {
      fill: "#4E4ECE"
    },
    width: 3.934,
    height: 139.424
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E4ECE"
    },
    d: "M152.556,146.268v10.451c0,7.624,6.181,13.805,13.805,13.805h10.383 c7.624,0,13.805-6.181,13.805-13.805v-10.451H152.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3FF"
    },
    d: "M114.563,146.268v10.451c0,7.624,6.181,13.805,13.805,13.805h10.383 c7.624,0,13.805-6.181,13.805-13.805v-10.451H114.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3FF"
    },
    d: "M190.55,146.268v10.451c0,7.624,6.181,13.805,13.805,13.805h10.383 c7.624,0,13.805-6.181,13.805-13.805v-10.451H190.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E4ECE"
    },
    d: "M304.53,146.268v10.451c0,7.624,6.181,13.805,13.805,13.805h10.383 c7.625,0,13.805-6.181,13.805-13.805v-10.451H304.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3FF"
    },
    d: "M356.328,170.523h10.383c7.625,0,13.805-6.181,13.805-13.805v-10.451h-37.993v10.451 C342.523,164.343,348.704,170.523,356.328,170.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E4ECE"
    },
    d: "M228.543,146.268v10.451c0,7.624,6.181,13.805,13.805,13.805h10.383 c7.624,0,13.805-6.181,13.805-13.805v-10.451H228.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3FF"
    },
    d: "M266.536,146.268v10.451c0,7.624,6.181,13.805,13.805,13.805h10.383 c7.624,0,13.805-6.181,13.805-13.805v-10.451H266.536z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A6AE2"
    },
    points: "185.723,104.981 152.556,146.268 190.55,146.268 210.449,104.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CACAFF"
    },
    points: "160.996,104.981 114.563,146.268 152.556,146.268 185.723,104.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CACAFF"
    },
    points: "210.449,104.981 190.55,146.268 228.543,146.268 235.176,104.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A6AE2"
    },
    points: "284.63,104.981 304.53,146.268 342.523,146.268 309.357,104.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CACAFF"
    },
    points: "342.523,146.268 380.517,146.268 334.084,104.981 309.357,104.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A6AE2"
    },
    points: "235.176,104.981 228.543,146.268 266.536,146.268 259.903,104.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CACAFF"
    },
    points: "259.903,104.981 266.536,146.268 304.53,146.268 284.63,104.981  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 209.608,
    y: 94.66,
    style: {
      fill: "#4E4ECE"
    },
    width: 75.864,
    height: 39.738
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 218.4531 122.6646)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'AllerDisplay'",
      fontSize: "26.3952px"
    }
  }, "SALE"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M138.867,334.489l5.419,26.412l20.493-17.521c-4.288-1.077-8.897-2.421-13.747-4.107 C146.64,337.748,142.581,336.125,138.867,334.489z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "168.625,344.437 178.708,369.443 195.714,348.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4CC4D"
    },
    points: "200.924,348.957 214.38,372.322 228.318,349.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "233.932,348.933 250.192,370.44 261.148,345.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4CC4D"
    },
    points: "265.351,345.054 284.203,364.33 291.952,338.505  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M124.196,325.598c0,0,27.352,23.568,93.411,23.568s106.92-23.568,106.92-23.568"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M125.746,325.598c0,0.856-0.694,1.55-1.55,1.55c-0.856,0-1.549-0.694-1.549-1.55 s0.694-1.55,1.549-1.55C125.052,324.048,125.746,324.742,125.746,325.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#130F40"
    },
    d: "M326.077,325.287c0,0.856-0.694,1.55-1.55,1.55c-0.856,0-1.55-0.694-1.55-1.55 c0-0.856,0.694-1.55,1.55-1.55C325.383,323.738,326.077,324.431,326.077,325.287z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E4ECE"
    },
    d: "M239.351,305.393h-29.009c-2.29,0-4.146-1.856-4.146-4.146v-18.349h37.301v18.348 C243.497,303.537,241.641,305.393,239.351,305.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M261.431,293.806H237.93c-0.916,0-1.658-0.742-1.658-1.658v-0.107c0-0.916,0.742-1.658,1.658-1.658 h23.501V293.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E4ECE"
    },
    d: "M262.83,289.728v4.717H248.4c-0.083,0.01-0.165,0.01-0.248,0.01c-1.301,0-2.364-1.053-2.364-2.364 c0-1.301,1.063-2.363,2.364-2.363H262.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6AE2"
    },
    d: "M265.193,292.095c0,1.306-1.059,2.365-2.365,2.365c-1.306,0-2.365-1.059-2.365-2.365 c0-1.306,1.059-2.365,2.365-2.365C264.134,289.73,265.193,290.789,265.193,292.095z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129.395,
    y: 216.856,
    transform: "matrix(0.9815 -0.1916 0.1916 0.9815 -44.9714 30.331)",
    style: {
      fill: "#4E4ECE"
    },
    width: 9.836,
    height: 61.586
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 134.449,
    y1: 222.685,
    x2: 130.802,
    y2: 223.397
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 135.789,
    y1: 229.548,
    x2: 132.142,
    y2: 230.26
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 137.129,
    y1: 236.411,
    x2: 133.482,
    y2: 237.123
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.469,
    y1: 243.275,
    x2: 134.823,
    y2: 243.987
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 139.81,
    y1: 250.138,
    x2: 136.163,
    y2: 250.85
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 141.15,
    y1: 257.002,
    x2: 137.503,
    y2: 257.714
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 142.49,
    y1: 263.865,
    x2: 138.843,
    y2: 264.577
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 143.83,
    y1: 270.728,
    x2: 140.183,
    y2: 271.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M173.127,245.61h-6.451l-0.95-2.467l-3.355-3.551h6.451c1.197,0,2.26,0.733,2.694,1.847 L173.127,245.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M168.916,278.732h-6.451c-6.895-15.235-4.232-31.171-2.9-36.921c0.155-0.65,0.516-1.208,1.012-1.6 c0.495-0.392,1.125-0.619,1.796-0.619c1.197,0,2.26,0.733,2.694,1.847l0.661,1.703 C164.364,249.759,162.496,264.55,168.916,278.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M160.109,245.61h-6.451l-0.949-2.467l-3.355-3.551h6.451c1.197,0,2.26,0.733,2.694,1.847 L160.109,245.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M155.898,278.732h-6.451c-6.895-15.235-4.232-31.171-2.9-36.921c0.155-0.65,0.516-1.208,1.011-1.6 c0.495-0.392,1.125-0.619,1.796-0.619c1.197,0,2.26,0.733,2.694,1.847l0.661,1.703 C151.346,249.759,149.478,264.55,155.898,278.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6756"
    },
    d: "M184.466,280.363h-30.449l-1.342-35.868h20.901c0.991,0,1.899,0.547,2.353,1.424 C178.696,251.235,187.882,270.124,184.466,280.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M150.018,280.363v-33.207c0-1.47,1.191-2.661,2.661-2.661l0,0c0.991,0,1.899,0.546,2.356,1.425 c2.763,5.315,11.944,24.202,8.53,34.443H150.018z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 159.438,
    y1: 255.434,
    x2: 180.336,
    y2: 255.434
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E77"
    },
    points: "166.96,258.257 164.122,258.257 161.67,252.581 164.509,252.581  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8E77"
    },
    points: "178.417,258.257 175.578,258.257 173.127,252.581 175.965,252.581  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.182,
    y: 272.883,
    style: {
      fill: "#4E4ECE"
    },
    width: 28.973,
    height: 32.513
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.573,
    y: 272.883,
    style: {
      fill: "#6A6AE2"
    },
    width: 35.61,
    height: 32.513
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B3B3FF"
    },
    points: "155.935,280.277 120.326,280.277 125.573,272.883 161.182,272.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A6AE2"
    },
    points: "166.429,280.277 195.402,280.277 190.155,272.883 161.182,272.883  "
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 125.573,
    y1: 305.396,
    x2: 161.182,
    y2: 305.396
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 415.107,
    y1: 242.135,
    x2: 376.659,
    y2: 405.34
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 401.436,405.34 413.424,225.451 465.774,405.34  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#54C3EA"
    },
    points: "462.628,377.3 398.29,377.3 382.362,235.324 446.701,235.324  "
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9938 0 0.1115 0.9938 392.6458 262.5277)",
    style: {
      fill: "#171659",
      fontFamily: "'AllerDisplay'",
      fontSize: "23.0944px"
    }
  }, "FLEA"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9938 0 0.1115 0.9938 393.7315 274.2084)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'AllerDisplay'",
      fontSize: "13.3886px"
    }
  }, "MARKET")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9938 0 0.1115 0.9938 395.7072 289.7962)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'AllerDisplay'",
      fontSize: "16.9638px"
    }
  }, "SUPER")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9938 0 0.1115 0.9938 397.3676 308.1014)",
    style: {
      fill: "#171659",
      fontFamily: "'AllerDisplay'",
      fontSize: "23.0944px"
    }
  }, "SALE"), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6A6AE2"
    },
    points: "449.018,346.588 455.766,342.206 448.035,337.826 452.293,331.011 443.778,329.746  444.883,321.527 436.89,323.553 434.688,315.181 428.434,320.201 423.24,312.962 419.672,320.201 412.294,315.178  411.968,323.551 403.523,321.526 406.47,329.744 398.24,331.007 404.025,337.826 397.278,342.206 405.008,346.588  400.75,353.403 409.264,354.668 408.161,362.886 416.152,360.861 418.355,369.232 424.61,364.211 429.802,371.451  433.372,364.211 440.75,369.233 441.076,360.861 449.522,362.888 446.574,354.668 454.805,353.403  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9938 0 0.1115 0.9938 408.4079 353.7381)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'AllerDisplay'",
      fontSize: "18.1072px"
    }
  }, "50%"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9938 0 0.1115 0.9938 407.0915 340.2621)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'AllerDisplay'",
      fontSize: "16.2208px"
    }
  }, "up to"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E4ECE"
    },
    d: "M461.49,380.052h-61.986c-1.226,0-2.257-0.921-2.393-2.14l0,0c-0.16-1.427,0.957-2.677,2.393-2.677 h61.986c1.226,0,2.257,0.921,2.393,2.14l0,0C464.044,378.803,462.927,380.052,461.49,380.052z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M247.028,259.076c-0.589,0.504-1.476,0.435-1.98-0.154s-0.435-1.476,0.155-1.979 c0.589-0.504,1.476-0.435,1.98,0.154C247.686,257.686,247.617,258.572,247.028,259.076z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -5.7531 5.582)",
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 245.313,
    cy: 258.591,
    rx: 11.004,
    ry: 11.004
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M233.591,281.847l-13.08-15.295c-2.448-2.862-1.352-7.294,2.15-8.689l11.899-4.751l14.497,16.952 l-6.54,11.017C240.596,284.324,236.047,284.719,233.591,281.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M247.901,268.714l-12.187-14.25c3.537-0.174,7.12,1.231,9.602,4.133 C247.799,261.498,248.631,265.256,247.901,268.714z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EB4D4B"
    },
    points: "229.583,259.707 224.592,240.796 226.675,240.071 233.092,258.484  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M265.129,261.228c-0.151-4.631-2.576-10.317-2.917-14.143c-0.084-0.941-1.194-1.392-1.91-0.775 c-0.955,0.824-1.698,2.571-0.592,6.274c0,0-5.505,0.129-7.827-0.086c-2.322-0.215-2.795,2.58-0.817,2.796 c0,0-1.634-0.086-1.763,1.892c-0.129,1.978,1.935,1.591,1.935,1.591s-1.118,0.817-0.989,1.806 c0.129,0.989,1.075,1.419,2.064,1.032c0,0-0.903,0.946-0.344,2.279c0.297,0.708,1.128,0.61,1.843,0.363 c0.899-0.311,2.906-0.313,3.805-0.004l0.545,0.187L265.129,261.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.708,393.502h-15.619c0,0-11.95-25.071-18.931-57.424 c-2.311-10.722-4.076-22.257-4.681-33.935v-5.584l17.899-2.752C314.377,293.806,318.106,352.625,335.708,393.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.034,297.526c0,0-6.105,23.603-5.243,95.975h16.482c0,0,0.496-56.96,7.437-90.242v-5.733 H287.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M302.177,244.939l-10.053,2.535l-3.662-10.037c-4.839,2.678-7.811,0.301-9.576-3.917l-1.857,0.47 c-0.609,0.152-1.102-0.482-0.81-1.038l0.668-1.258c0.547-1.029,0.73-2.211,0.51-3.356c-0.383-1.998-0.149-2.084-0.283-4.096 c0.002-0.009,0.002-0.009,0.002-0.009c-0.014-0.221-0.021-0.431-0.037-0.643c0.003-0.018-0.004-0.028-0.001-0.046 c-0.012-0.484-0.006-0.964,0.037-1.447c0,0,0,0,0.002-0.009c0.028-0.404,0.084-0.811,0.16-1.224 c1.339-7.34,8.841-11.64,16.194-9.427c5.492,1.656,7.311,5.425,7.526,10.973c0.125,3.212-0.653,5.349-2.651,7.437 c-0.76,0.779-1.173,1.802-1.201,2.851c-0.016,0.533,0.059,1.073,0.246,1.589L302.177,244.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M280.225,227.284c0.129,0.535,0.033,1.017-0.215,1.077c-0.248,0.06-0.555-0.324-0.684-0.859 c-0.13-0.535-0.033-1.017,0.215-1.077C279.789,226.365,280.095,226.749,280.225,227.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M305.71,303.259c-2.003,9.614-3.471,21.202-4.552,32.818"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#171659"
    },
    points: "298.439,405.34 265.131,405.34 270.787,401.728 274.142,399.581 283.638,393.501  296.86,393.501 297.355,397.207 297.954,401.728  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#171659"
    },
    points: "340.004,405.34 303.424,405.34 309.081,401.728 312.446,399.581 321.942,393.501  335.163,393.501 336.887,397.723 338.528,401.728  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M284.102,233.368c-0.031,1.662-0.526,3.726-3.324,0.96l0.495-0.382l2.735-2.116 C284.01,231.83,284.113,232.553,284.102,233.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.102,233.368c-0.42,0.42-0.915,0.728-1.27,0.919c-0.286,0.153-0.629,0.148-0.916-0.002 c-0.207-0.108-0.449-0.235-0.642-0.339l2.735-2.116C284.01,231.83,284.113,232.553,284.102,233.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M285.546,220.575c0,0-0.633,14.867,16.956,16.071l-2.408-1.978l2.408-0.913l-2.709-0.641 c-1.462-0.295,3.892-10.215-0.038-17.184L285.546,220.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8E77"
    },
    d: "M286.921,228.712c0,0,1.002-5.29,4.141-4.172c3.139,1.118,4.559,6.795-1.075,8.472"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M297.727,211.496c-1.848-1.889-8.134-1.662-13.108,0.351c-1.61,0.65-2.808,2.054-3.169,3.747 c-0.279,1.321-0.495,3.045-0.31,4.872c-2.178,0.485-4.098,1.125-5.759,1.817l-0.186-1.765c-0.227-2.167,0.537-4.325,2.085-5.852 c2.818-2.777,8.237-6.368,16.752-5.295C295.518,209.556,296.86,210.33,297.727,211.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M300.968,217.307l-19.343,5.605c-0.258-0.815-0.413-1.641-0.485-2.446 c-0.186-1.827,0.031-3.551,0.31-4.872c0.361-1.693,1.559-3.096,3.169-3.747c4.975-2.013,11.261-2.24,13.108-0.351 c0.052,0.062,0.103,0.124,0.155,0.186c0.114,0.165,0.227,0.341,0.32,0.516l1.682,3.096L300.968,217.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M281.625,222.912l-5.997,1.734l-8.072,2.343c0,0,2.642-2.57,7.824-4.707 c1.662-0.692,3.582-1.332,5.759-1.817C281.212,221.271,281.367,222.097,281.625,222.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB4D4B",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M289.106,228.699c0,0,0.133-3.141,2.258-2.411c2.124,0.731,0.372,4.058,0.372,4.058"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB4D4B",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M289.844,226.585c0,0,1.336,1.439,0.524,3.052"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M321.395,280.583l-3.014,2.126l-2.828,1.992l-5.347-23.285l-19.941,4.459 c-1.445,5.419-3.86,10.807-6.575,15.74c-1.228,2.25-2.529,4.397-3.829,6.42c-4.676,7.267-15.648,6.038-18.62-2.075l-3.994-10.941 c-0.217-0.588-0.32-1.208-0.32-1.817c0-0.919,0.237-1.817,0.702-2.622l-1.61-6.193l9.929-3.613l4.965,16.061l6.049-16.401 c0.599-1.631,1.373-3.179,2.302-4.624c1.796-2.828,4.17-5.274,6.998-7.153l9.816-6.523l11.447,1.91 c2.942,0.495,5.543,2.209,7.122,4.738c0.113,0.186,0.227,0.382,0.351,0.568c3.963,6.678,7.37,16.896,9.217,23.027 C325.131,275.432,323.995,278.735,321.395,280.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M318.071,299.626L318.071,299.626v2.931c-15.575,2.064-33.886,0.702-33.886,0.702l0.258-2.859 l-0.062-0.06c-1.772-1.735-2.534-4.238-2.091-6.678c0.8-4.403,1.231-8.419,1.399-12.047c0.661-14.13-2.715-22.532-4.428-25.804 c1.796-2.828,4.17-5.274,6.998-7.153l9.816-6.523l11.447,1.91c2.942,0.495,5.543,2.209,7.122,4.738 c0.113,0.186,0.227,0.382,0.351,0.568l3.385,33.359l1.343,13.221C319.87,297.369,319.24,298.776,318.071,299.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M318.071,299.626l0.021,2.415c0,1.104-0.815,2.044-1.909,2.168 c-12.696,1.445-26.599,0.795-30.738,0.547c-0.681-0.041-1.197-0.619-1.166-1.301l0.165-3.055l-0.062-0.062 c-1.775-1.734-2.539-4.232-2.095-6.678c0.805-4.397,1.238-8.412,1.404-12.045c0.661-14.13-2.715-22.532-4.428-25.804 c1.796-2.828,4.17-5.274,6.998-7.153l1.28-0.846l2.302-1.538l6.234-4.139l11.447,1.91c1.951,0.33,3.747,1.187,5.192,2.477 c0.743,0.65,1.404,1.404,1.93,2.26c0.113,0.186,0.227,0.382,0.351,0.568l3.385,33.359l1.342,13.222 C319.867,297.366,319.237,298.78,318.071,299.626z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 318.38,
    y1: 282.709,
    x2: 315.281,
    y2: 252.172
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M290.264,265.875c-1.445,5.419-3.86,10.807-6.575,15.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M285.472,300.404c0,0,17.461,1.799,30.621-0.777"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB4D4B"
    },
    d: "M287.538,247.809l2.307-1.535c0,0,7.325,5.403,16.228,2.823c8.902-2.58,11.547-5.032,6.774-10.128 l0,0c0.741-1.404,0.559-3.117-0.461-4.334l0,0c-1.229-1.467-3.206-2.067-5.039-1.517c-4.1,1.231-11.559,3.745-17.475,7.275 c-2.051,1.224-3.074,3.637-2.615,5.981L287.538,247.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M312.714,246.522c-1.528,0.908-3.757,1.734-6.637,2.57c-8.908,2.58-16.236-2.818-16.236-2.818"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 288.299,
    y1: 247.323,
    x2: 290.783,
    y2: 245.646
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.816,244.517c0,0,10.095,1.161,13.449-2.806"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "297.954,401.728 298.439,405.34 265.131,405.34 270.787,401.728  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "340.004,405.34 303.424,405.34 309.081,401.728 338.528,401.728  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M361.164,293.033 v-29.358c0-2.042,1.656-3.698,3.698-3.698l0,0c2.042,0,3.698,1.655,3.698,3.698v1.457"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "371.302,276.001 365.978,281.938 361.156,276.56 356.341,281.939 351.026,276  361.164,360.656  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B3B3FF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 361.156,
    y1: 278.214,
    x2: 361.156,
    y2: 325.444
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#B3B3FF",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 356.205,283.172 361.156,327.461 366.038,283.172  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171659"
    },
    d: "M371.217,395.029l3.592,10.311h-27.29l3.592-10.311c-5.243-1.321-8.939-6.348-8.33-11.994 l7.948-73.345h20.87l7.948,73.345C380.155,388.681,376.46,393.708,371.217,395.029z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#130F40",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 351.11,
    y1: 395.029,
    x2: 371.217,
    y2: 395.029
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M120.326,205.51c-9.263,0-16.773,7.51-16.773,16.773c0-9.263-7.51-16.773-16.773-16.773 c9.263,0,16.773-7.51,16.773-16.773C103.553,198,111.063,205.51,120.326,205.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M271.082,216.675c-9.263,0-16.773,7.51-16.773,16.773c0-9.263-7.51-16.773-16.773-16.773 c9.263,0,16.773-7.51,16.773-16.773C254.309,209.165,261.819,216.675,271.082,216.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CC4D"
    },
    d: "M129.962,187.902c-4.04,0-7.315,3.275-7.315,7.315c0-4.04-3.275-7.315-7.315-7.315 c4.04,0,7.315-3.275,7.315-7.315C122.647,184.627,125.922,187.902,129.962,187.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.472,203.034c-4.04,0-7.315,3.275-7.315,7.315c0-4.04-3.275-7.315-7.315-7.315 c4.04,0,7.315-3.275,7.315-7.315C236.157,199.758,239.432,203.034,243.472,203.034z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorsVector);
export default __webpack_public_path__ + "static/media/VendorsVector.747be5b7de2cdb4ba367a62daafadaa5.svg";
export { ForwardRef as ReactComponent };